/* tslint:disable */
/* eslint-disable */
export enum WorkLsCharakteristikEnum {
  B = 'B',
  C = 'C',
  D = 'D',
  Dii = 'DII',
  Diii = 'DIII',
  Nhs = 'NHS'
}
